import { MainLayout } from 'shared/ui/layout/main';

import { RolesTabs } from '../tabs';

export function RolesLayout() {
  return <MainLayout tabs={<RolesTabs />} />;
}
